import styles from "./styles.module.css";

export default function Features({ section, items = [] }) {
  return (
    <div className={styles.paper}>
      <div className={styles.featureTitle}>{section}</div>
      <div style={{ display: "flex" }}>
        {items.map((i) => {
          return (
            <div key={i} className={styles.featureItem}>
              {i}
            </div>
          );
        })}
      </div>
    </div>
  );
}
